import request from '@/utils/request'

export function fetch(query) {
  return request({
    url: 'products',
    method: 'get',
    params: query
  })
}

export function fetchProduct(id) {
  return request({
    url: `products/${id}`,
    method: 'get',
  })
}

export function fetchAll(query) {
  return request({
    url: 'products/all',
    method: 'get',
    params: query
  })
}
